var _path, _g, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegulationBadgeGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 50,
    viewBox: "0 0 38 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H32C35.3137 0 38 2.68629 38 6V16C38 19.3137 35.3137 22 32 22H6C2.68629 22 0 19.3137 0 16V6Z",
    fill: "#FDE000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62490_54696)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 11,
    r: 5,
    fill: "#FFB005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5754 6.68292C13.771 6.36827 14.229 6.36827 14.4246 6.68292L19.5871 14.986C19.7942 15.3191 19.5547 15.75 19.1625 15.75H8.83747C8.44528 15.75 8.20577 15.3191 8.41285 14.986L13.5754 6.68292Z",
    fill: "#C2C2C2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 34C0 30.6863 2.68629 28 6 28H32C35.3137 28 38 30.6863 38 34V44C38 47.3137 35.3137 50 32 50H6C2.68629 50 0 47.3137 0 44V34Z",
    fill: "#FF95B2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_62490_54696)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 39,
    r: 5,
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5754 34.6829C13.771 34.3683 14.229 34.3683 14.4246 34.6829L19.5871 42.986C19.7942 43.3191 19.5547 43.75 19.1625 43.75H8.83747C8.44528 43.75 8.20577 43.3191 8.41285 42.986L13.5754 34.6829Z",
    fill: "#E52055"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62490_54696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_62490_54696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(8 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegulationBadgeGroup);
export default __webpack_public_path__ + "static/media/regulation-badge-group.4128a75655b75a50297f1e704ce3de9a.svg";
export { ForwardRef as ReactComponent };